import {Component, input, output} from "@angular/core";
import {Translations} from "@translations";
import {DataPermissions, IHasPermissions} from "@models";
import {MatIcon} from "@angular/material/icon";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {MatIconButton} from "@angular/material/button";
import {MatDivider} from "@angular/material/divider";
import {SimButton} from "@common/ui/button/sim-button.component";
import {HasDataPermissionDirective} from "@common/directives/perm-directives/has-data-permission.directive";

export type MenuAction = {
	fontIcon: string;
	click: Function;
	labelKey: string;
	disabled?: boolean;
	condition?: boolean;
	permission?: {hasDataPermission: keyof typeof DataPermissions | Array<keyof typeof DataPermissions>; permissionObj: IHasPermissions};
};

@Component({
	selector: "sim-action-menu",
	templateUrl: "./action-menu.component.html",
	styleUrl: "./action-menu.component.scss",
	standalone: true,
	imports: [MatIcon, MatMenu, MatMenuTrigger, MatIconButton, MatDivider, SimButton, HasDataPermissionDirective],
})
export class ActionMenuComponent {
	// Input
	public actions = input.required<MenuAction[]>();
	public isDeletable = input<boolean>(true);

	// Readonly
	protected readonly T = Translations;

	// Output
	onDelete = output<void>();
}
